import {Component, Input, OnInit} from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {MODIFIERS_TYPES_LIST} from "../../../enums/e-modifiers";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {IDocument} from "../../../interfaces/document.definition";
import {WatchService} from "../../../services/watch.service";

@Component({
  selector: 'go-influence-receiver',
  templateUrl: './go-influence-receiver.component.html',
  styles: []
})
export class GoInfluenceReceiverComponent extends GoBaseComponent {

  @Input() document:IDocument;

  MODIFIERS_LIST = MODIFIERS_TYPES_LIST;
  currentReceiveModifier:any;
  currentIgnoreModifier:any;

  constructor(private watchService:WatchService) {
    super(GO_COMPONENTS.INFLUENCE_RECEIVER);
  }

  ngOnInit() {

  }

  onAddReceiveClick() {
    //console.log(this.componentType);
    if (this.currentReceiveModifier) {
      if (this.document[this.componentType].receiveOnly == null) {
        this.document[this.componentType].receive = [];
      }
      this.document[this.componentType].receiveOnly.push(this.currentReceiveModifier.id);
      this.watchService.notify();
    }
  }

  onAddIgnoreClick() {
    //console.log(this.componentType);
    if (this.currentIgnoreModifier) {
      if (this.document[this.componentType].ignore == null) {
        this.document[this.componentType].ignore = [];
      }
      this.document[this.componentType].ignore.push(this.currentIgnoreModifier.id);
      this.watchService.notify();
    }
  }

  getModifierLabel(id) {
    return this.MODIFIERS_LIST.find((item) => item.id == id).label;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-influence-receiver/go-influence-receiver.component.ts